export interface ErrorPageProps {
  isError: boolean,
  message: string;
}

export enum CustomerStepsType {
  CustomerScore = "STAGE_1",
  CustomerFeedback = "STAGE_2",
  CustomerThanks = "STAGE_3"
}